var _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg08018EmployeeprofileLw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hintergrund"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Hilfslinien_anzeigen"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Vordergrund"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "FL\\xC4CHE_SW"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#08191F",
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E2F100",
    d: "M7.046,21.973v-1.904l1.902-4.091h6.122l1.961,4.085v1.91h-1.996 v-1.456l-1.222-2.543h-3.592l-1.18,2.537v1.462H7.046z M12.032,10.971c-0.553,0-1,0.448-1,1c0,0.553,0.447,1,1,1 c0.552,0,1-0.447,1-1C13.032,11.418,12.584,10.971,12.032,10.971z M12.028,8.981c1.656,0,3.001,1.34,3.001,2.993 c0,1.652-1.345,2.992-3.001,2.992c-1.657,0-3-1.34-3-2.992C9.028,10.321,10.371,8.981,12.028,8.981z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M26.014,22.97V7.978H6.043V22.97H26.014z M28.013,24.966H4.046V5.982h23.967V24.966z M17.024,11.971h7.996 v2h-7.996V11.971z M17.024,8.977h7.996v2h-7.996V8.977z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg08018EmployeeprofileLw);
export default __webpack_public_path__ + "static/media/08_018_Employee profile_LW.eb469ef0.svg";
export { ForwardRef as ReactComponent };